import axios from "axios";

import { ApiService } from "../../../servicios/api.service";
import LocalStorageKeys from "../../../data/localStorageKeys";

export class VentaApi {
    static endPoint = "venta/comerciante/";

    static get BasePath() {
        return ApiService.api + this.endPoint;
    }

    static get AuthHeader() {
        return "Bearer " + localStorage.getItem(LocalStorageKeys.tokenComercio);
    }

    static get Headers() {
        return { Authorization: this.AuthHeader };
    }

    static get Config() {
        return { headers: this.Headers };
    }


    static async approveById(pagoId) {
        await axios.patch(this.BasePath + "approve/" + pagoId, {}, this.Config);
    }

    static async getPendingList() {
        const response = await axios.get(this.BasePath + "pending", this.Config);

        return response.data;
    }

    static async rejectById(pagoId) {
        await axios.patch(this.BasePath + "reject/" + pagoId, {}, this.Config);
    }
}